const routes = [
	{
		path: '/postulaciones',
		component: () => import('@/views/dashboard/applications/List.vue'),
		meta: {
			auth: true
		}
	}
];

export default routes;